@if (dataSource.data.length) {
  <app-table-general-simple
    [dataSource]="dataSource"
    [headers]="headers"
    [isLoading]="load"
    (idEmitter)="activityfuntion($event)"
  ></app-table-general-simple>
}
